import React from "react";

const AccountIcon = ({ color = "#0A61F5" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="10" height="10" rx="3.5" stroke={color} />
      <rect x="0.5" y="13.5" width="10" height="10" rx="3.5" stroke={color} />
      <rect x="13.5" y="0.5" width="10" height="10" rx="3.5" stroke={color} />
      <rect x="13.5" y="13.5" width="10" height="10" rx="3.5" stroke={color} />
    </svg>
  );
};

export default AccountIcon;
